/*!
 * vue-flexboxgrid v1.5.0
 * (c) 2017 Alexandre Chopin
 * Released under the MIT License.
 */
(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global['vue-flexboxgrid'] = global['vue-flexboxgrid'] || {})));
}(this, (function (exports) { 'use strict';

var Container = {render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes},[_vm._t("default")],2)},staticRenderFns: [],
  props: {
    hero: { type: Boolean, default: false },
    fluid: { type: Boolean, default: false }
  },
  computed: {
    classes: function classes () {
      var c = this.fluid ? 'container-fluid ' : 'container ';
      c += this.hero ? 'hero' : '';
      return c
    }
  }
};

var Row = {render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes},[_vm._t("default")],2)},staticRenderFns: [],
  props: {
    reverse: { type: Boolean, default: false },
    startXs: { type: Boolean, default: false },
    centerXs: { type: Boolean, default: false },
    endXs: { type: Boolean, default: false },
    topXs: { type: Boolean, default: false },
    middleXs: { type: Boolean, default: false },
    bottomXs: { type: Boolean, default: false },
    aroundXs: { type: Boolean, default: false },
    betweenXs: { type: Boolean, default: false },
    startSm: { type: Boolean, default: false },
    centerSm: { type: Boolean, default: false },
    endSm: { type: Boolean, default: false },
    topSm: { type: Boolean, default: false },
    middleSm: { type: Boolean, default: false },
    bottomSm: { type: Boolean, default: false },
    aroundSm: { type: Boolean, default: false },
    betweenSm: { type: Boolean, default: false },
    startMd: { type: Boolean, default: false },
    centerMd: { type: Boolean, default: false },
    endMd: { type: Boolean, default: false },
    topMd: { type: Boolean, default: false },
    middleMd: { type: Boolean, default: false },
    bottomMd: { type: Boolean, default: false },
    aroundMd: { type: Boolean, default: false },
    betweenMd: { type: Boolean, default: false },
    startLg: { type: Boolean, default: false },
    centerLg: { type: Boolean, default: false },
    endLg: { type: Boolean, default: false },
    topLg: { type: Boolean, default: false },
    middleLg: { type: Boolean, default: false },
    bottomLg: { type: Boolean, default: false },
    aroundLg: { type: Boolean, default: false },
    betweenLg: { type: Boolean, default: false }
  },
  computed: {
    classes: function classes () {
      var c = this.reverse ? 'row reverse' : 'row ';
      c += this.startXs ? ' start-xs' : (this.centerXs ? ' center-xs' : (this.endXs ? ' end-xs' : ''));
      c += this.startSm ? ' start-sm' : (this.centerSm ? ' center-sm' : (this.endSm ? ' end-sm' : ''));
      c += this.startMd ? ' start-md' : (this.centerMd ? ' center-md' : (this.endMd ? ' end-md' : ''));
      c += this.startLg ? ' start-lg' : (this.centerLg ? ' center-lg' : (this.endLg ? ' end-lg' : ''));
      c += this.topXs ? ' top-xs' : (this.middleXs ? ' middle-xs' : (this.bottomXs ? ' bottom-xs' : ''));
      c += this.topSm ? ' top-sm' : (this.middleSm ? ' middle-sm' : (this.bottomSm ? ' bottom-sm' : ''));
      c += this.topMd ? ' top-md' : (this.middleMd ? ' middle-md' : (this.bottomMd ? ' bottom-md' : ''));
      c += this.topLg ? ' top-lg' : (this.middleLg ? ' middle-lg' : (this.bottomLg ? ' bottom-lg' : ''));
      c += this.aroundXs ? ' around-xs' : (this.betweenXs ? ' between-xs' : '');
      c += this.aroundSm ? ' around-sm' : (this.betweenSm ? ' between-sm' : '');
      c += this.aroundMd ? ' around-md' : (this.betweenMd ? ' between-md' : '');
      c += this.aroundLg ? ' around-lg' : (this.betweenLg ? ' between-lg' : '');
      return c
    }
  }
};

var Column = {render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes},[_vm._t("default")],2)},staticRenderFns: [],
  props: {
    firstXs: { type: Boolean, default: false },
    lastXs: { type: Boolean, default: false },
    firstSm: { type: Boolean, default: false },
    lastSm: { type: Boolean, default: false },
    firstMd: { type: Boolean, default: false },
    lastMd: { type: Boolean, default: false },
    firstLg: { type: Boolean, default: false },
    lastLg: { type: Boolean, default: false },
    xsOffset: { type: String, validator: function validator (v) { var i = parseInt(v); return !isNaN(i) && v > 0 && v < 13 } },
    smOffset: { type: String, validator: function validator (v) { var i = parseInt(v); return !isNaN(i) && v > 0 && v < 13 } },
    mdOffset: { type: String, validator: function validator (v) { var i = parseInt(v); return !isNaN(i) && v > 0 && v < 13 } },
    lgOffset: { type: String, validator: function validator (v) { var i = parseInt(v); return !isNaN(i) && v > 0 && v < 13 } },
    xs: { type: String, default: '12', validator: function validator (v) { var i = parseInt(v); return !isNaN(i) && v > 0 && v < 13 } },
    sm: { type: String, validator: function validator (v) { var i = parseInt(v); return !isNaN(i) && v > 0 && v < 13 } },
    md: { type: String, validator: function validator (v) { var i = parseInt(v); return !isNaN(i) && v > 0 && v < 13 } },
    lg: { type: String, validator: function validator (v) { var i = parseInt(v); return !isNaN(i) && v > 0 && v < 13 } }
  },
  computed: {
    classes: function classes () {
      var c = 'col';
      c += this.firstXs ? ' first-xs' : (this.lastXs ? ' last-xs' : '');
      c += this.firstSm ? ' first-sm' : (this.lastSm ? ' last-sm' : '');
      c += this.firstMd ? ' first-md' : (this.lastMd ? ' last-md' : '');
      c += this.firstLg ? ' first-lg' : (this.lastLg ? ' last-lg' : '');
      c += this.xsOffset ? ' col-xs-offset-' + this.xsOffset : '';
      c += this.smOffset ? ' col-sm-offset-' + this.smOffset : '';
      c += this.mdOffset ? ' col-md-offset-' + this.mdOffset : '';
      c += this.lgOffset ? ' col-lg-offset-' + this.lgOffset : '';
      c += ' col-xs-' + this.xs;
      c += this.sm ? ' col-sm-' + this.sm : '';
      c += this.md ? ' col-md-' + this.md : '';
      c += this.lg ? ' col-lg-' + this.lg : '';
      return c
    }
  }
};

function plugin (Vue) {
  Vue.component('container', Container);
  Vue.component('row', Row);
  Vue.component('column', Column);
}

// Install by default if using the script tag
if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(plugin);
}

var version = '1.5.0';

exports['default'] = plugin;
exports.Container = Container;
exports.Row = Row;
exports.Column = Column;
exports.version = version;

Object.defineProperty(exports, '__esModule', { value: true });

})));



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flexboxgrid/dist/vue-flexboxgrid.js
// module id = 5UqA
// module chunks = 0